export default "__VITE_ASSET__BG$XIZaI__"